import { render, staticRenderFns } from "./OrcamentoCadastro.vue?vue&type=template&id=6baf93e2&scoped=true"
import script from "./OrcamentoCadastro.vue?vue&type=script&lang=js"
export * from "./OrcamentoCadastro.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoCadastro.vue?vue&type=style&index=0&id=6baf93e2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf93e2",
  null
  
)

export default component.exports